window.dianji = {}
window.dianji.isWx = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'



// WEBPACK FOOTER //
// ./src/utils/variable.js